<div class="deviation-table-container">
    <div class="select-container">
        <mat-form-field>
            <mat-label>Select SW Version</mat-label>
            <mat-select [formControl]="swVersion" multiple id="sw-select">
                <mat-select-trigger>
                    @if(swVersion.value[0] == 'select-all') {
                    All versions
                    }@else {
                    {{swVersion.value?.[0] || ''}}
                    @if ((swVersion.value?.length || 0) > 1) {
                    <span class="additional-selection">
                        (+{{ (swVersion.value?.length || 0) - 1 }}
                        {{ swVersion.value?.length === 2 ? "other" : "others" }})
                    </span>
                    }
                    }
                </mat-select-trigger>
                <mat-option id="select-all" value="select-all" selectAll [allValues]="swVersionFilter">Select
                    All</mat-option>
                @for (version of swVersionFilter; track version) {
                <mat-option [value]="version">{{version}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="mat-elevation-z2 table-container">
        <table mat-table matSort matSortActive="numberOfReports" [dataSource]="tableDataSource" id="deviation-table"
            matSortDirection="desc">

            <!-- ID Column -->
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef> Title </th>
                <td mat-cell *matCellDef="let row"> {{row.title}} </td>
            </ng-container>

            <!-- Progress Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> Ticket ID </th>
                <td mat-cell *matCellDef="let row">
                    <a [href]="'https://dev.azure.com/wheelme/' + adoProject + '/_workitems/edit/' + row.id"
                        target="_blank">
                        {{row.id}}
                    </a>

                </td>
            </ng-container>

            <ng-container matColumnDef="swVersion">
                <th mat-header-cell *matHeaderCellDef> SW Version</th>
                <td mat-cell *matCellDef="let row"> {{row.swFoundIn}}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="numberOfReports">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="number-of-reports"> Number of Reports </th>
                <td mat-cell *matCellDef="let row"> {{row.numberOfReports}} </td>
            </ng-container>

            <!-- Fruit Column -->
            <ng-container matColumnDef="totalDowntime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header id="total-downtime"> Total Downtime </th>
                <td mat-cell *matCellDef="let row"> {{row.totalDowntime}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['title', 'id', 'swVersion', 'numberOfReports', 'totalDowntime']">
            </tr>
            <tr mat-row
                *matRowDef="let row; columns: ['title', 'id', 'swVersion', 'numberOfReports', 'totalDowntime'];">
            </tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data to show</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 50]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>
